const PeopleLevelInBrandColumns = () => {
  return [
    {
      title: 'Task',
      dataIndex: 'task',
      align: 'center',
      render: (text, record, index) => {
        if ([0, 4, 8, 12, 16].includes(index)) {
          return {
            children: text,
            props: {
              rowSpan: 4,
            },
          };
        }
        return {
          children: text,
          props: {
            rowSpan: 0,
          },
        };
      }
    },
    {
      title: 'Report Level',
      dataIndex: 'report_level',
      align: 'center',
    },
    {
      title: 'Department',
      dataIndex: 'department',
      editable: true,
    },
    {
      title: 'Position',
      dataIndex: 'position',
      editable: true,
    },
    {
      title: 'Working hour',
      dataIndex: 'working_hour',
      editable: true,
      align: 'right',
    },
  ];
};

export default PeopleLevelInBrandColumns;
